// extracted by mini-css-extract-plugin
module.exports = {"blank-story":"tnc6s","story-heading":"_1Lo1l","author-list":"tXTMp","published-time":"_3I_X1","blank-story-hero-image-wrapper":"_3hbGi","blank-story-hero-image":"iJZWf"};